<template>
    <v-row class="descriptionEvent my-3">
        <v-col cols="9" class="mx-auto" v-if="eventDescription">
            <v-card flat>
                <v-card-text class="pt-0 px-0">
                    <fieldset class="srs_fset">
                        <legend class="srs_lgd">{{ $t('registerEvent.description') }}</legend>
                        <v-row>
                            <v-col cols="12">
                                <p v-html="eventDescription"></p>
                            </v-col>
                        </v-row>
                    </fieldset>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="9" class="mx-auto">
            <v-row>
                <v-col md="6" cols="12" v-if="registrationObj.eventSel && registrationObj.eventSel.address && registrationObj.eventSel.address != ''">
                    <v-text-field outlined disabled :value="registrationObj.eventSel.address" :label="$t('registerEvent.address')" dense></v-text-field>
                </v-col>
                <v-col md="6" cols="12" v-if="registrationObj.eventSel && registrationObj.eventSel.city && registrationObj.eventSel.city != ''">
                    <v-text-field outlined disabled :value="registrationObj.eventSel.city" :label="$t('registerEvent.city')" dense></v-text-field>
                </v-col>
                <v-col md="6" cols="12" v-if="registrationObj.eventSel && registrationObj.eventSel.state && registrationObj.eventSel.state != ''">
                    <v-text-field outlined disabled :value="registrationObj.eventSel.state" :label="$t('registerEvent.state')" dense></v-text-field>
                </v-col>
                <v-col md="6" cols="12" v-if="registrationObj.eventSel && registrationObj.eventSel.country && registrationObj.eventSel.country != ''">
                    <v-text-field outlined disabled :value="registrationObj.eventSel.country" :label="$t('registerEvent.country')" dense></v-text-field>
                </v-col>
                <v-col md="6" cols="12" v-if="registrationObj.eventSel && registrationObj.eventSel.zip && registrationObj.eventSel.zip != ''">
                    <v-text-field outlined disabled :value="registrationObj.eventSel.zip" :label="$t('registerEvent.zip')" dense></v-text-field>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { VTextField, VRow, VCol, VCard, VCardText } from 'vuetify/lib';

export default {
    components: { VTextField, VRow, VCol, VCard, VCardText },
    props: { 
        registrationObj: Object,
        eventDescription: String
    }
}
</script>

<style lang="scss">
.srs_fset {
  padding: 0.35em 0.625em 0.75em !important;
  //margin: 5px !important;
  border: 1px solid rgba(0,0,0,.12) !important;
}

.srs_lgd {
  width: auto !important;
  font-size: 15px !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}
.descriptionEvent {
    .v-text-field__slot input {
        color: rgba(0,0,0,0.8) !important;
    }
    .v-card fieldset p p {
        color: rgba(0,0,0,0.8) !important; 
    }
}
</style>